import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';

type LatLngFormProps = {
  disabled?: boolean;
  fieldName: string;
  id?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const LatLngForm = (props: LatLngFormProps): JSX.Element => {
  const {
    disabled = false,
    fieldName,
    onChange,
    id = `latLngForm-${fieldName}`,
  } = props;
  const { t } = useTranslation();
  const { control, formState } = useFormContext();
  const labelKey = fieldName.toLowerCase().includes('lat')
    ? 'addIncidentReport.inputs.latitude.label'
    : 'addIncidentReport.inputs.longitude.label';

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState }): JSX.Element => {
        const { ref, ...muiFieldProps } = field;
        return (
          <TextField
            id={id}
            label={t(labelKey)}
            fullWidth
            {...muiFieldProps}
            inputRef={ref}
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message}
            placeholder="00.000000"
            disabled={formState.isSubmitting || disabled}
            {...(onChange ? { onChange } : {})}
          />
        );
      }}
    />
  );
};
